export default "__VITE_ASSET__KM6vWh8$__$_?nuxt_component=async&nuxt_component_name=SvgoOnboardingMiner&nuxt_component_export=default__"